import * as React from 'react'
import { Downloads } from '../../components/UI/Downloads'
import { Styled } from './styled'
import { sbEditable } from '@storyblok/storyblok-editable'

export const DownloadsBlog = ({ blok }) => {
  return (
    <Styled.Wrapper {...sbEditable(blok)}>
      {blok.headline && <Styled.Headline as={blok.headlineSyntax || 'h2'}>{blok.headline}</Styled.Headline>}
      <Downloads downloads={blok.downloadsItems} />
    </Styled.Wrapper>
  )
}
